import React from 'react';
import Spin from '../spin';
import Empty from '../empty';
import 'cropperjs/dist/cropper.css';
import './index.less';
import loadingImg from './data-loading';
import errorImg from './data-error';
import emptyImg from './data-empty';
const sizeStyle = {
    small: { width: 40, height: 40 },
    middle: { width: 60, height: 60 },
    large: { width: 80, height: 80 },
};
const STATUS = {
    LOADING: 'loading',
    ERROR: 'error',
    EMPTY: 'empty',
    SUCCESS: 'success',
};
class DataStatus extends React.Component {
    render() {
        const { status, loadingImg, loadingIndicator, loadingInline, loadingImgStyles, errorImg, errorDescription, errorOtherProps, emptyImg, emptyDescription, emptyOtherProps, children, loadingImgSize = 'middle', } = this.props;
        return (<>
                {status === STATUS.LOADING ? (<div className={'data-status-loading-container ' + (loadingInline ? 'inline' : '')}>
                        <Spin indicator={loadingIndicator || (<img src={loadingImg} alt="" style={Object.assign(Object.assign({}, sizeStyle[loadingImgSize]), loadingImgStyles)}/>)}/>
                    </div>) : status === STATUS.ERROR ? (<div className="data-status-container">
                        <Empty image={errorImg} description={errorDescription} {...errorOtherProps}/>
                    </div>) : status === STATUS.EMPTY ? (<div className="data-status-container">
                        <Empty image={emptyImg} description={emptyDescription} {...emptyOtherProps}/>
                    </div>) : ((status === STATUS.SUCCESS || !status) && children)}
            </>);
    }
}
DataStatus.STATUS = STATUS;
DataStatus.defaultProps = {
    loadingImg: loadingImg,
    loadingIndicator: null,
    loadingInline: false,
    loadingImgStyles: null,
    errorImg: errorImg,
    errorDescription: '数据错误',
    errorOtherProps: null,
    emptyImg: emptyImg,
    emptyDescription: '暂无数据',
    emptyOtherProps: null,
    loadingImgSize: 'middle',
};
export default DataStatus;
